import { healthreadLight as light } from './light';
import { healthreadContrast as contrast } from './contrast';

export const appThemes = {
  light,
  contrast,
};
